"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.StyledParagraph=void 0;var _styledComponents=_interopRequireDefault(require("styled-components"));var _constants=require("../../_constants");var _style=require("../../Icon/_style");var _utils=require("../_utils");var _style2=require("../Heading/_style");var _constants2=require("./_constants");function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e};}const StyledParagraph=exports.StyledParagraph=_styledComponents.default.p`
  position: relative;
  box-sizing: border-box;
  display: block;
  padding: 0;
  font-family: ${_ref=>{let{theme}=_ref;return(0,_utils.getParagraphFontFamily)({theme});}};
  font-weight: ${_constants2.STYLES.FONT_WEIGHT};
  line-height: ${_ref2=>{let{theme,sSize}=_ref2;return(0,_utils.getParagraphLineHeight)({theme,size:sSize});}};
  margin: ${_ref3=>{let{noMargin}=_ref3;return noMargin?0:_constants2.STYLES.MARGIN;}};
  font-size: ${_ref4=>{let{theme,sSize}=_ref4;return(0,_utils.getFontSize)({theme,size:sSize,mediaSize:_constants.MEDIA_SIZES.S});}};
  text-align: ${props=>(0,_utils.getTextAlign)(props.sTextAlign)};
  color: ${_ref5=>{let{theme,sColor}=_ref5;return(0,_utils.getColor)({theme,color:sColor});}};

  :first-child {
    margin-top: 0;
  }

  :last-child {
    margin-bottom: 0;
  }

  ${_style2.StyledHeading} + & {
    margin-top: 0;
  }

  @media (${_constants.MEDIA.TABLET}) {
    font-size: ${_ref6=>{let{theme,sSize}=_ref6;return(0,_utils.getFontSize)({theme,size:sSize,mediaSize:_constants.MEDIA_SIZES.M});}};
  }

  @media (${_constants.MEDIA.DESKTOP}) {
    font-size: ${_ref7=>{let{theme,sSize}=_ref7;return(0,_utils.getFontSize)({theme,size:sSize,mediaSize:_constants.MEDIA_SIZES.L});}};
  }

  ${_style.StyledIconSvg} {
    ${_ref8=>{let{theme,sColor}=_ref8;return sColor&&`fill: ${(0,_utils.getColor)({theme,color:sColor})}`;}}
  }
`;